module.exports = __webpack_public_path__ + "static/media/failedIcon.fa192f62.svg";